import React, {useMemo} from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core';
import {DashboardEarnedProducts} from '../../../../reducers/dashboard';
import {getDirectionStyles} from '../../../../utils/ThemeUtils';
import {Select} from '../../../../components';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center'
    },
    selectRoot: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    select: {
        width: theme.spacing(50),
        '& input': {
            height: '41.1px',
            textTransform: 'capitalize'
        },
        [theme.breakpoints.down('sm')]: {
            flex: 1,
            width: '100%'
        }
    },
    label: {
        paddingLeft: getDirectionStyles(theme.direction)(0, theme.spacing(2)),
        paddingRight: getDirectionStyles(theme.direction)(theme.spacing(2), 0),

        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    }
}));

export interface SupporterGamesProps {
    label?: string;
    products: DashboardEarnedProducts;
    selectedProductId?: string | number;
    onChange: (productId: string | number) => void;
}

const SupporterGames: React.FC<SupporterGamesProps> = ({
    selectedProductId,
    label,
    products,
    onChange = () => {}
}) => {
    const styles = useStyles();
    const {lastFetch, data} = products || {};
    const {title = selectedProductId} = (data && data[selectedProductId]) || {};

    const options = useMemo(() => {
        const mappedOptions = {
            fortnite: {
                label: 'Fortnite',
                value: 'fortnite'
            }
        };

        for (const productId in data) {
            if (typeof productId === 'string') {
                mappedOptions[productId] = {
                    label: data[productId].title,
                    value: productId
                };
            }
        }

        return Object.values(mappedOptions);
    }, [lastFetch]);

    return (
        <Box className={styles.root}>
            {label && (
                <Typography className={styles.label} variant="body2" color="textSecondary">
                    {label}
                </Typography>
            )}
            <Select
                size="small"
                wrapperClassName={styles.selectRoot}
                className={styles.select}
                options={options}
                value={title || selectedProductId}
                onChange={option => onChange(option.value as number)}
                trackEventProps={{
                    interactionType: 'Click',
                    eventCategory: 'MediaCreator',
                    eventAction: 'ClickSupporterChartGame'
                }}
            />
        </Box>
    );
};

export default SupporterGames;
